import React from 'react';
import './AudioStatus.scss';
type AudioStatusProps = {
  isSpeaking: boolean;
};
export const AudioStatus: React.FC<AudioStatusProps> = ({ isSpeaking }) => {
  return (
    <div className="recording-indicator">
      <span className={`outer-circle ${!isSpeaking ? 'recording' : ''}`}>
        <span className={`inner-circle ${!isSpeaking ? 'recording animate-ping' : ''}`} />
      </span>
      <span className="recording-label">{!isSpeaking ? 'Listening' : 'Talk to interuppt'}</span>
    </div>
  );
};
